window.themeObj = {
  init: () => {
    window.themeObj.templates.init();
    window.themeObj.sections.init();
  }
};

window.themeObj.tools = {
  toCapitalize: (string) => {
    const words = string.split(' ');

    for (let i = 0; i < words.length; i++) {
      words[i] = words[i][0].toUpperCase() + words[i].substr(1);
    }

    return words.join(' ');
  }
};

window.themeObj.sections = {
  init: () => {
    window.themeObj.sections.footerDescription();
  },
  footerDescription: () => {
    const wrapper = document.querySelector('.collection-description--mobile');

    if (wrapper) {
      const rte = wrapper.querySelector('.rte');
        
      if (rte && wrapper.clientHeight >= 200) {
        wrapper.classList.add('is-collapsed');
      
        const button = document.querySelector('.collection-description__button');
  
        button.addEventListener('click', () => {
          wrapper.classList.remove('is-collapsed');
        });
      }
    }
  }
};

window.themeObj.templates = {
  init: () => {
    window.themeObj.templates.collection.init();
  }
};

window.themeObj.templates.collection = {
  init: () => {
    
    if (document.body.classList.contains('template-collection')) {
      // new window.themeObj.templates.collection.default();
    }
  },
  default: class {
    
    constructor () {
      const obj = this;
    }
  }
};

window.themeObj.init();